export default "__VITE_ASSET__7b26e7fc__"